import { BankAccountType } from './bank-account-type';
import { EarlyPaymentStatus } from './early-payment-status';
import { InvoiceBuyerApprovalStatus } from './invoice-buyer-approval-status';
import { InvoiceFundingStatus } from './invoice-funding-status';
import { Date } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { Money } from '@lsq-frontend/remote-services/all-java/common-mk0';

export class InvoiceSummary {
    public refInvoiceKey: string;
    public invoiceDate: object;
    public buyerApprovalStatus: InvoiceBuyerApprovalStatus;
    public buyerName: string;
    public invoiceNumber: string;
    public invoiceDueDate: object;
    public advanceRate: number;
    public invoiceAmount: Money;
    public finalApprovedAmount: Money;
    public discountAmount: Money;
    public availableAmount: Money;
    public fundingDate: object;
    public fundingStatus: InvoiceFundingStatus;
    public dueIn: number;
    public feeRateHundredthOfBps: number;
    public isGroup: boolean;
    public refGroupedInvoiceKey: string;
    public groupId: string;
    public sellerName: string;
    public groupedInvoiceNumberMatched: boolean;
    public refBuyerKey: string;
    public totalGroupedInvoiceCount: number;
    public invoiceDateNew: Date;
    public invoiceDueDateNew: Date;
    public fundingDateNew: Date;
    public earlyPaymentStatus: EarlyPaymentStatus;
    public canBeRevoked: boolean;
    public invoiceStatus: InvoiceFundingStatus;
    public buyerDiscountAmount: Money;
    public supplierDiscountAmount: Money;
    public buyerDiscountPercentage: number;
    public buyerPaidTransactionFee: boolean;
    public bankAccountType: BankAccountType;
    public paymentMethod: string;
    public sellerKey: string;
    constructor(obj?: {
       refInvoiceKey?: string;
       invoiceDate?: object;
       buyerApprovalStatus?: InvoiceBuyerApprovalStatus;
       buyerName?: string;
       invoiceNumber?: string;
       invoiceDueDate?: object;
       advanceRate?: number;
       invoiceAmount?: Money;
       finalApprovedAmount?: Money;
       discountAmount?: Money;
       availableAmount?: Money;
       fundingDate?: object;
       fundingStatus?: InvoiceFundingStatus;
       dueIn?: number;
       feeRateHundredthOfBps?: number;
       isGroup?: boolean;
       refGroupedInvoiceKey?: string;
       groupId?: string;
       sellerName?: string;
       groupedInvoiceNumberMatched?: boolean;
       refBuyerKey?: string;
       totalGroupedInvoiceCount?: number;
       invoiceDateNew?: Date;
       invoiceDueDateNew?: Date;
       fundingDateNew?: Date;
       earlyPaymentStatus?: EarlyPaymentStatus;
       canBeRevoked?: boolean;
       invoiceStatus?: InvoiceFundingStatus;
       buyerDiscountAmount?: Money;
       supplierDiscountAmount?: Money;
       buyerDiscountPercentage?: number;
       buyerPaidTransactionFee?: boolean;
       bankAccountType?: BankAccountType;
       paymentMethod?: string;
       sellerKey?: string;
    }) {
        if (obj != null) {
            this.refInvoiceKey = typeof obj.refInvoiceKey === 'undefined' ? this.refInvoiceKey : obj.refInvoiceKey;
            this.invoiceDate = typeof obj.invoiceDate === 'undefined' ? this.invoiceDate : obj.invoiceDate;
            this.buyerApprovalStatus = typeof obj.buyerApprovalStatus === 'undefined' ? this.buyerApprovalStatus : obj.buyerApprovalStatus;
            this.buyerName = typeof obj.buyerName === 'undefined' ? this.buyerName : obj.buyerName;
            this.invoiceNumber = typeof obj.invoiceNumber === 'undefined' ? this.invoiceNumber : obj.invoiceNumber;
            this.invoiceDueDate = typeof obj.invoiceDueDate === 'undefined' ? this.invoiceDueDate : obj.invoiceDueDate;
            this.advanceRate = typeof obj.advanceRate === 'undefined' ? this.advanceRate : obj.advanceRate;
            this.invoiceAmount = typeof obj.invoiceAmount === 'undefined' ? this.invoiceAmount : obj.invoiceAmount;
            this.finalApprovedAmount = typeof obj.finalApprovedAmount === 'undefined' ? this.finalApprovedAmount : obj.finalApprovedAmount;
            this.discountAmount = typeof obj.discountAmount === 'undefined' ? this.discountAmount : obj.discountAmount;
            this.availableAmount = typeof obj.availableAmount === 'undefined' ? this.availableAmount : obj.availableAmount;
            this.fundingDate = typeof obj.fundingDate === 'undefined' ? this.fundingDate : obj.fundingDate;
            this.fundingStatus = typeof obj.fundingStatus === 'undefined' ? this.fundingStatus : obj.fundingStatus;
            this.dueIn = typeof obj.dueIn === 'undefined' ? this.dueIn : obj.dueIn;
            this.feeRateHundredthOfBps = typeof obj.feeRateHundredthOfBps === 'undefined' ? this.feeRateHundredthOfBps : obj.feeRateHundredthOfBps;
            this.isGroup = typeof obj.isGroup === 'undefined' ? this.isGroup : obj.isGroup;
            this.refGroupedInvoiceKey = typeof obj.refGroupedInvoiceKey === 'undefined' ? this.refGroupedInvoiceKey : obj.refGroupedInvoiceKey;
            this.groupId = typeof obj.groupId === 'undefined' ? this.groupId : obj.groupId;
            this.sellerName = typeof obj.sellerName === 'undefined' ? this.sellerName : obj.sellerName;
            this.groupedInvoiceNumberMatched = typeof obj.groupedInvoiceNumberMatched === 'undefined' ? this.groupedInvoiceNumberMatched : obj.groupedInvoiceNumberMatched;
            this.refBuyerKey = typeof obj.refBuyerKey === 'undefined' ? this.refBuyerKey : obj.refBuyerKey;
            this.totalGroupedInvoiceCount = typeof obj.totalGroupedInvoiceCount === 'undefined' ? this.totalGroupedInvoiceCount : obj.totalGroupedInvoiceCount;
            this.invoiceDateNew = typeof obj.invoiceDateNew === 'undefined' ? this.invoiceDateNew : obj.invoiceDateNew;
            this.invoiceDueDateNew = typeof obj.invoiceDueDateNew === 'undefined' ? this.invoiceDueDateNew : obj.invoiceDueDateNew;
            this.fundingDateNew = typeof obj.fundingDateNew === 'undefined' ? this.fundingDateNew : obj.fundingDateNew;
            this.earlyPaymentStatus = typeof obj.earlyPaymentStatus === 'undefined' ? this.earlyPaymentStatus : obj.earlyPaymentStatus;
            this.canBeRevoked = typeof obj.canBeRevoked === 'undefined' ? this.canBeRevoked : obj.canBeRevoked;
            this.invoiceStatus = typeof obj.invoiceStatus === 'undefined' ? this.invoiceStatus : obj.invoiceStatus;
            this.buyerDiscountAmount = typeof obj.buyerDiscountAmount === 'undefined' ? this.buyerDiscountAmount : obj.buyerDiscountAmount;
            this.supplierDiscountAmount = typeof obj.supplierDiscountAmount === 'undefined' ? this.supplierDiscountAmount : obj.supplierDiscountAmount;
            this.buyerDiscountPercentage = typeof obj.buyerDiscountPercentage === 'undefined' ? this.buyerDiscountPercentage : obj.buyerDiscountPercentage;
            this.buyerPaidTransactionFee = typeof obj.buyerPaidTransactionFee === 'undefined' ? this.buyerPaidTransactionFee : obj.buyerPaidTransactionFee;
            this.bankAccountType = typeof obj.bankAccountType === 'undefined' ? this.bankAccountType : obj.bankAccountType;
            this.paymentMethod = typeof obj.paymentMethod === 'undefined' ? this.paymentMethod : obj.paymentMethod;
            this.sellerKey = typeof obj.sellerKey === 'undefined' ? this.sellerKey : obj.sellerKey;
        }
    }
}
